var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('benefit-notification-box-base',{attrs:{"icon-path":'subscription/discount.svg',"description":_vm.description,"title":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }